import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class SignupForNewsletterRequest extends baseRequest{

    constructor(afterSuccess) {
        super();
        this.dispatch     = null;
        this.response     = null;
        this.name         = 'signupForNewsletter';
        this.Config       = new AppConfig();
        this.afterSuccess = afterSuccess;
    }

    //old call
    // not used. moved to rtk mutation
    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.signupForNewsletter, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setNewsletterStatus(this.response.status === 1));
        this.dispatch(Actions.setNewsletterSubscriptionResultText(this.response.data.result));
        this.afterSuccess();
    }
}

export default SignupForNewsletterRequest;
